import React from 'react'
import { History } from 'history'
import { Link as RouterLink } from 'react-router-dom'

import { IconWarning } from 'components/ui/icons'
import { space } from 'helpers/style'
import styled from 'styled'

const Message = styled.div`
  display: flex;
  margin-bottom: ${space(3)};
  padding: ${space(4)};
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grayL80};
  border-radius: 4px;
`

const Link = styled(RouterLink)`
  display: flex;
  flex-direction: column;

`

const MessageDetails = styled.div`
  display: flex;
  flex-direction: row;
`

const MessageTitle = styled.span`
  display: block;
  margin-bottom: ${space(2)};
  color: ${({ theme }) => theme.color.darkText};
  font-size: ${({ theme }) => theme.font.size.base};
  font-weight: ${({ theme }) => theme.font.weight.base};
`

const MessageText = styled.span`
  display: block;
  margin-left: ${space(2)};
  color: ${({ theme }) => theme.color.warning};
  font-size: ${({ theme }) => theme.font.size.small};
  font-weight: ${({ theme }) => theme.font.weight.light};
`

type Props = {
  readonly title: string;
  readonly text: string;
  readonly link?: History.LocationDescriptor<any>;
}

export const IssueItem = ({ link, title, text }: Props) => (
  (link ?
    <Message>
      <Link to={link} target="_blank">
        <>
          <MessageTitle>{title}</MessageTitle>
          <MessageDetails>
            <IconWarning size="small" color="warning" />
            <MessageText>{text}</MessageText>
          </MessageDetails>
        </>
      </Link>
    </Message> :
    <Message>
      <MessageTitle>{title}</MessageTitle>
      <MessageDetails>
        <IconWarning size="small" color="warning" />
        <MessageText>{text}</MessageText>
      </MessageDetails>
    </Message>
  )
)
